import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const StyledDrawerLink = styled(Link)`
  display: flex;
  align-items: center;
  color: ${(p) => p.isActive && p.theme.alias.primary};
  padding: ${(p) => p.theme.space[2]} ${(p) => p.theme.space[3]};
  box-shadow: ${(p) => p.$isIsolated && p.theme.shadows.y};
  justify-content: space-between;
  background-color: transparent;

  &:hover {
    background-color: ${(p) => p.theme.alias.shadow};
  }

  &:focus-visible {
    box-shadow: ${(p) => p.theme.shadows.focusInner};
  }
`;

export const StyledDrawerLinkButton = styled(StyledDrawerLink).attrs({
  as: 'button',
})`
  background: transparent;
`;

export const StyledDrawerText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;

  & + svg {
    margin-left: ${(p) => p.theme.space[1]};
  }
`;
